//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

export const Burn = {
  filter: [
    {
      label: "Loyalty Account Id",
      key: "loyalty_id",
    },
    {
      label: "Bill To",
      key: "customer_billto_account_number",
    },
  ],
  group: [
    {
      label: "Loyalty Account Id",
      key: "loyalty_id",
    },
    {
      label: "Bill To",
      key: "customer_billto_account_number",
    },
  ],
  columns: [
    {
      label: "Loyalty ID",
      key: "loyalty_id",
    },
    {
      label: "Bill to Account ID",
      key: "customer_billto_account_number",
    },
    {
      label: "Shipto ID",
      key: "customer_account_number",
    },
    {
      label: "Points Redeemed",
      key: "points_redeemed",
    },
    {
      label: "Credit Value",
      key: "credit_issued",
    },
    {
      label: "Redemption Date",
      key: "date_of_transaction",
    },
    {
      label: "Tier",
      key: "tier",
    },
    {
      label: "Customer Sales Division Code",
      key: "customer_sales_division_code",
    },
    {
      label: "Market Class Code",
      key: "market_class_code",
    },
    {
      label: "Segment Code",
      key: "segment_code",
    },
    {
      label: "Customer Account Type Code",
      key: "customer_account_type_code",
    },
    {
      label: "Name",
      key: "redemption_by_name"
    },
    {
      label: "Email",
      key: "redemption_by_email"
    },
    {
      label: "Role",
      key: "redemption_by_role"
    },
    {
      label:"Billto Province Code",
      key:"billto_province_code"
    },
    {
      label:"Shipto Province Code",
      key:"shipto_province_code"
    }
  ],
};

export const Earn = {
  filter: [
    {
      label: "Loyalty Account Id",
      key: "loyalty_id",
    },
    {
      label: "Bill To",
      key: "customer_billto_account_number",
    },
    {
      label: "Ship to ID",
      key: "customer_account_number",
    },
    {
      label: "Brand Name Code",
      key: "product_brand_name_code",
    },
    {
      label: "Cost Center",
      key: "gl_cost_center_code",
    },
    {
      label: "Primary Class ID",
      key: "product_primary_class_id",
    },
    {
      label: "Rule ID",
      key: "rule_id",
    },
    {
      label: "Promotional",
      key: "is_promotional",
      type: "Boolean",
    },
    {
      label: "Order ID",
      key: "order_id",
    },
    {
      label: "Transaction Type",
      key: "transaction_type",
    },
  ],
  filterDataType: {
    is_promotional: "Boolean",
  },
  group: [
    {
      label: "Bill To",
      key: "customer_billto_account_number",
    },
    {
      label: "Loyalty Account ID",
      key: "loyalty_id",
    },
    {
      label: "Brand Name Code",
      key: "product_brand_name_code",
    },
    {
      label: "Cost Center",
      key: "gl_cost_center_code",
    },
    {
      label: "Primary Class ID",
      key: "product_primary_class_id",
    },
    {
      label: "Transaction Type",
      key: "transaction_type",
    },
    {
      label: "Label Class Code",
      key: "label_class_code",
    },
    {
      label: "Order ID",
      key: "order_id",
    },
    {
      label: "Rule ID",
      key: "rule_id",
    },
  ],
  columns: [
    {
      label: "Loyalty ID",
      key: "loyalty_id",
    },
    {
      label: "Bill to Account ID",
      key: "customer_billto_account_number",
    },
    {
      label: "Ship to ID",
      key: "customer_account_number",
    },
    {
      label: "Purchase Amount",
      key: "extended_sales_amount",
    },
    {
      label: "Points Allocated",
      key: "points",
    },
    {
      label: "Expiration Date",
      key: "points_expiration_date",
    },
    {
      label: "Order Date",
      key: "order_date",
    },
    {
      label: "Rule Description",
      key: "rule_description",
    },
    {
      label: "Cost Center",
      key: "gl_cost_center_code",
    },
    {
      label: "Promotional",
      key: "is_promotional",
    },
    {
      label: "Transaction Type",
      key: "transaction_type",
    },
    {
      label: "Type",
      key: "type",
    },
    {
      label: "Label Class Code",
      key: "label_class_code",
    },
    {
      label: "Product Code",
      key: "product_code",
    },
    {
      label: "Brand Name Code",
      key: "product_brand_name_code",
    },
    {
      label: "Order ID",
      key: "order_id",
    },
    {
      label: "Rule ID",
      key: "rule_id",
    },
    {
      label: "Primary Class ID",
      key: "product_primary_class_id",
    },
    {
      label: "Primary Class Description",
      key: "product_primary_class_description",
    },
    {
      label: "Post Date",
      key: "post_date",
    },
    {
      label: "Transaction Status",
      key: "transaction_status",
    },
    {
      label: "Sales Division Code",
      key: "customer_sales_division_code",
    },
    {
      label: "Market Class",
      key: "market_class_code",
    },
    {
      label: "Segment Code",
      key: "segment_code",
    },
    {
      label: "Tier",
      key: "tier",
    },
    {
      label: "Consent Status",
      key: "consent_flag",
    },
    {
      label: "Is Bronze",
      key: "IsBronze",
    },
    {
      label: "Primary Major Class Code",
      key: "primary_major_class_code",
    },

    {
      label: "Primary Submajor Class Code",
      key: "primary_submajor_class_code",
    },

    {
      label: "Primary Minor Class Code",
      key: "primary_minor_class_code",
    },

    {
      label: "Tier Ratio",
      key: "tier_ratio",
    },
    {
      label:"Billto Province Code",
      key:"billto_province_code"
    },
    {
      label:"Shipto Province Code",
      key:"shipto_province_code"
    },
     {
      label:"Equipment Order Number",
      key:"equipment_order_number"
    }
  ],
};

export const PointsBalance = {
  filter: [],
  group: [
    {
      label: "Loyalty Account Id",
      key: "loyalty_id",
    },
    {
      label: "Bill To",
      key: "customer_billto_account_number",
    },
  ],
  columns: [
    {
      label: "Loyalty ID",
      key: "loyalty_id",
    },
    {
      label: "Bill to Account ID",
      key: "customer_billto_account_number",
    },
    {
      label: "Points Balance",
      key: "points_balance",
    },
    {
      label: "Available To Redeem",
      key: "available_to_redeem",
    },
    {
      label: "Status",
      key: "status",
    },
    {
      label: "Date of Report",
      key: "date_of_report",
    },
    {
      label: "Consecutive Negative (days)",
      key: "negative_count",
    },
  ],
};

export const CostCenter = {};

export const RollForward = {
  filter: [],
  group: [],
  columns: [
    {
      label: "MNTH",
      key: "calculated_month",
    },
    {
      label: "Starting Points",
      key: "starting_balance_points",
    },
    {
      label: "ACH",
      key: "ach_points",
    },
    {
      label: "Premium",
      key: "premium_points",
    },
    {
      label: "Rebate",
      key: "rebate_points",
    },
    {
      label: "Legacy",
      key: "legacy_points",
    },
    {
      label: "Sale Points",
      key: "sales_points",
    },
    {
      label: "Courtesy",
      key: "points_adjustment",
    },
    {
      label: "Expired",
      key: "points_expiring",
    },
    {
      label: "Redeemed",
      key: "points_redeemed",
    },
    {
      label: "Ending Balance",
      key: "overall_balance",
    },
    {
      label: "MNTH ",
      key: "loyalty_calc_month",
    },
    {
      label: "Outstanding Balance by Month",
      key: "outstanding_balance",
    },
    {
      label: "Current Month Points Issued",
      key: "points_issued",
    },
    {
      label: "Redemption",
      key: "points_used",
    },
    {
      label: "Expired by Month",
      key: "fiscal_points_expired",
    },
    {
      label: "Redemption %",
      key: "redemption_percentage",
    },
  ],
};

export const MemberIDStatusConfig = {
  filter: [
    {
      label: "Consent",
      key: "consent_flag",
    },
    {
      label: "Tier",
      key: "tier",
    },
    {
      label: "Active",
      key: "is_active",
    },
    {
      label: "Org ID",
      key: "loyalty_organization_name",
    },
    {
      label: "Site ID",
      key: "loyalty_site_id",
    },
    {
      label: "Enrolled By",
      key: "request_by",
    },
    {
      label: "Type",
      key: "member_account_created_by",
    },
    {
      label: "Privilege Code",
      key: "privilege_code",
    },
  ],
  filterDataType2: {
    tier: {
      type: "Select",
      data: [
        { label: "Core", value: "Core" },
        { label: "Select", value: "Select" },
        { label: "Elite", value: "Elite" },
       
      ],
    },
    consent_flag: {
      type: "Select",
      data: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    is_active: {
      type: "Select",
      data: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    loyalty_organization_name: {
      type: "Async",
      key: "loyalty_organization_name",
    },
    loyalty_site_id: {
      type: "Async",
      key: "loyalty_site_id",
    },
    member_account_created_by: {
      type: "Select",
      data: [
        { label: "Enrollment", value: 1 },
        { label: "Manual Enrollment", value: 3 },
        { label: "Transfer", value: 2 },
        { label: "Manual Transfer", value: 4 },
      ],
    },
    privilege_code: {
      type: "Async",
      key: "privilege_code",
    },
  },
  filterDataType: {
    tier: {
      type: "Select",
      data: [
        { label: "Bronze", value: "Bronze" },
        { label: "Silver", value: "Silver" },
        { label: "Gold", value: "Gold" },
        { label: "Platinum", value: "Platinum" },
      ],
    },
    consent_flag: {
      type: "Select",
      data: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    is_active: {
      type: "Select",
      data: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    loyalty_organization_name: {
      type: "Async",
      key: "loyalty_organization_name",
    },
    loyalty_site_id: {
      type: "Async",
      key: "loyalty_site_id",
    },
    member_account_created_by: {
      type: "Select",
      data: [
        { label: "Enrollment", value: 1 },
        { label: "Manual Enrollment", value: 3 },
        { label: "Transfer", value: 2 },
        { label: "Manual Transfer", value: 4 },
      ],
    },
    privilege_code: {
      type: "Async",
      key: "privilege_code",
    },
  },
  group: [
    {
      label: "Loyalty ID",
      key: "loyalty_id",
    },
    {
      label: "Tier",
      key: "tier",
    },
    {
      label: "Privilege Code",
      key: "privilege_code",
    },
  ],
  columns: [
    {
      label: "Loyalty ID",
      key: "loyalty_id",
    },
    {
      label: "Tier",
      key: "tier",
    },
    {
      label: "Status",
      key: "is_active",
    },
    {
      label: "Ship to ID",
      key: "customer_account_number",
    },
    {
      label: "Bill to ID",
      key: "customer_billto_account_number",
    },
    {
      label: "Privilege Code",
      key: "privilege_code",
    },
    {
      label: "Consented",
      key: "consented",
    },
    {
      label: "New Enrollment",
      key: "new_enrollment",
    },
    {
      label: "Transfers",
      key: "transfers",
    },
    {
      label: "Email",
      key: "email",
    },
    {
      label: "Email Sent Status",
      key: "email_sent_status",
    },
    {
      label: "Email Sent Date",
      key: "run_date",
    },
  ],
};

export const CustomerStatus = {
  type: [
    { label: "All", key: "All" },
    { label: "Enrollment", key: "Enrollment" },
    { label: "Transfer", key: "Transfer" },
  ],
  columns: [
    {
      label: "",
      key: "type",
    },
    {
      label: "Customer",
      key: "customer",
    },
    {
      label: "FSC",
      key: "fsc",
    },
    {
      label: "Program Admin",
      key: "program_admin",
    },
    {
      label: "Total",
      key: "total",
    },
  ],
};
export const PromoEarn = {
 
  columns: [
    {
      label: "Loyalty ID",
      key: "loyalty_id",
    },
    {
      label: "Billto",
      key: "Billto",
    },
    {
      label: "Ship to ID",
      key: "customer_account_number",
    },
    {
      label: "Location",
      key: "Location",
    },
    {
      label: "Practice Name",
      key: "Practice_Name",
    },
  
    {
      label: "Phone Number",
      key: "Phone_Number",
    },
 
    {
      label: "Order ID",
      key: "order_id",
    },
    {
      label: "Order Number",
      key: "order_number",
    },
    {
      label: "Order line number",
      key: "order_line_number",
    },
    {
      label: "Purchase Amount",
      key: "extended_sales_amount",
    },
    {
      label: "Rate",
      key: "tier_ratio",
    },
    {
      label: "Points Allocated",
      key: "points",
    },
 
    {
      label: "Base Points",
      key: "base_points",
    },
    {
      label: "Promo Points",
      key: "promo_points",
    },
    {
      label: "Type",
      key: "type",
    },
    {
      label: "Order Date",
      key: "order_date",
    },
    {
      label: "Invoice Date",
      key: "post_date",
    },
    {
      label: "Rule ID",
      key: "rule_id",
    },
    {
      label: "Rule Description",
      key: "rule_description",
    },

   
    {
      label: "Product Code",
      key: "product_code",
    },
    {
      label: "Product Short Description",
      key: "product_short_description",
    },
    {
      label: "Brand Name Code",
      key: "product_brand_name_code",
    },

    {
      label: "Segment Code",
      key: "segment_code",
    },
    
    {
      label: "Primary major class code",
      key: "Primary_major_class_code",
    },
     {
      label:"Equipment Order Number",
      key:"equipment_order_number"
    }
   
   
   
  ],
};
 


export const FSCSummary = {
  filter: [
    {
      label: "Enrollment",
      key: "Enrollment",
    },
   
    {
      label: "FSC Email",
      key: "FSC Email",
    },
    {
      label: "First Name",
      key: "First Name",
    },
    {
      label: "Last Name",
      key: "Last Name",
    },
    {
      label: "Redemption",
      key: "Redemption",
    },
     {
      label: "Transfer",
      key: "Transfer",
    },
  ],

  columns: [
    {
      label: "First Name",
      key: "First Name",
    },
    {
      label: "Last Name",
      key: "Last Name",
    },
    {
      label: "FSC Email",
      key: "FSC Email",
    },
    {
      label: "Enrollment",
      key: "Enrollment",
    },  
    {
      label: "Transfer",
      key: "Transfer",
    },

    {
      label: "Redemption",
      key: "Redemption",
    },
  ],

  
};

export const WelcomeEmail = [
  
    {
      label: "Member ID",
      key: "Member ID",
    },
    {
      label: "First Name",
      key: "First Name",
    },
    {
      label: "Last Name",
      key: "Last Name",
    },
    {
      label: "Email",
      key: "Email",
    },
    {
      label: "Loyalty Status",
      key: "Loyalty Status",
    },
   
 

  
     
  ];

  // export const MarketoMailchimp = {
  //   filter: [    
  //     {
  //       label: "First Name",
  //       key: "first_name",
  //     },
  //     {
  //       label: "Last Name",
  //       key: "last_name",
  //     },
  //     {
  //       label: "Email",
  //       key: "email",
  //     },
  //     {
  //       label: "Loyalty Id",
  //       key: "loyalty_id",
  //     },
  //     {
  //       label: "Role",
  //       key: "role",
  //     }
  //   ],
  //   columns: [
  //     {
  //       label: "First Name",
  //       key: "first_name",
  //     },
  //     {
  //       label: "Last Name",
  //       key: "last_name",
  //     },
  //     {
  //       label: "Email",
  //       key: "email",
  //     },
  //     {
  //       label: "Customer Billto Account Number",
  //       key: "customer_billto_account_number",
  //     },    
  //     {
  //       label: "Loyalty Id",
  //       key: "loyalty_id",
  //     },
  //     {
  //       label: "Role",
  //       key: "role",
  //     },
  //     {
  //       label: "Points Left To Redeem",
  //       key: "points_left_to_redeem",
  //     },
  //     {
  //       label: "Total Points Available",
  //       key: "total_points_available",
  //     },
  //     // {
  //     //   label: "Points Earned",
  //     //   key: "points_earned",
  //     // },
  //     // {
  //     //   label: "Points Redeemed",
  //     //   key: "points_redeemed",
  //     // },
  //     {
  //       label: "Points Expiring At Month End",
  //       key: "points_expiring_at_month_end",
  //     },
  //     {
  //       label: "Upcoming Points Expiration Date",
  //       key: "upcoming_points_expiration_date",
  //     },
  //     {
  //       label: "Tier",
  //       key: "tier",
  //     },
  //     // {
  //     //   label: "Sales Amount",
  //     //   key: "sales_amount",
  //     // },
  //     // {
  //     //   label: "Anniversary Date",
  //     //   key: "anniversary_date",
  //     // },
  //     {
  //       label: "Is Active",
  //       key: "is_active",
  //     },
  //     {
  //       label: "Consent Flag",
  //       key: "consent_flag",
  //     },
  //     {
  //       label: "System Managed",
  //       key: "system_managed",
  //     },
  
  //     // {
  //     //   label: "Create at",
  //     //   key: "created_at",
  //     // },
  //     // {
  //     //   label: "Mktcls Modified",
  //     //   key: "mktcls_modified",
  //     // },
  //     // {
  //     //   label: "Segment Code",
  //     //   key: "segment_code",
  //     // }
  //   ]
  // };

  export const MarketoMailchimp = {
    filter: [    
      {
        label: "First Name",
        key: "first_name",
      },
      {
        label: "Last Name",
        key: "last_name",
      },
      {
        label: "Email",
        key: "email",
      },
      {
        label: "Loyalty Id",
        key: "loyalty_id",
      },
      {
        label: "Role",
        key: "role",
      }
    ],
    columns: [
      
      {
        label: "Email Address",
        key: "email",
      },
       
      {
        label: "Thrive Loyalty ID Number",
        key: "loyalty_id",
      },
      
      {
        label: "Thrive Loyalty Total Points Balance",
        key: "total_points_available",
      },
      
      {
        label: "Thrive Loyalty Points expiring at the fiscal month end",
        key: "points_expiring_at_month_end",
      },
     
      {
        label: "Thrive Loyalty Current Tier",
        key: "tier",
      },
     
      {
        label: "Thrive Loyalty Anniversary Date",
        key: "anniversary_date",
      },
      
  
      
    ]
  };

  export const MarketoMailchimp_ca = {
    filter: [    
      {
        label: "First Name",
        key: "first_name",
      },
      {
        label: "Last Name",
        key: "last_name",
      },
      {
        label: "Email",
        key: "email",
      },
      {
        label: "Loyalty Id",
        key: "loyalty_id",
      },
      {
        label: "Role",
        key: "role",
      }
    ],
    columns: [
      {
        label: "First Name",
        key: "first_name",
      },
      {
        label: "Last Name",
        key: "last_name",
      },
      {
        label: "Email",
        key: "email",
      },
      {
        label: "Customer Billto Account Number",
        key: "customer_billto_account_number",
      },    
      {
        label: "Loyalty Id",
        key: "loyalty_id",
      },
      {
        label: "Role",
        key: "role",
      },
      {
        label: "Points Left To Redeem",
        key: "points_left_to_redeem",
      },
      {
        label: "Total Points Available",
        key: "total_points_available",
      },
      {
        label: "Points Earned",
        key: "points_earned",
      },
      {
        label: "Points Redeemed",
        key: "points_redeemed",
      },
      {
        label: "Points Expiring At Month End",
        key: "points_expiring_at_month_end",
      },
      {
        label: "Upcoming Points Expiration Date",
        key: "upcoming_points_expiration_date",
      },
      {
        label: "Tier",
        key: "tier",
      },
      {
        label: "Sales Amount",
        key: "sales_amount",
      },
      {
        label: "Anniversary Date",
        key: "anniversary_date",
      },
      {
        label: "Is Active",
        key: "is_active",
      },
      {
        label: "Consent Flag",
        key: "consent_flag",
      },
      {
        label: "System Managed",
        key: "system_managed",
      },
  
      // {
      //   label: "Create at",
      //   key: "created_at",
      // },
      {
        label: "Mktcls Modified",
        key: "mktcls_modified",
      },
      {
        label: "Segment Code",
        key: "segment_code",
      },
      {
        label: "Language",
        key: "language_code",
      }
    ]
  };
  export const pointexpirationmonthly = {
    columns: [
      {
        label: "Loyalty Id" ,
        key: "loyalty_id",
      },
      {
        label: "Customer Billto Account Number",
        key: "customer_billto_account_number",
      },
      {
        label: "Points Expiring",
        key: "points_expiring",
      },
      {
        label: "Points Expiration Date",
        key: "points_expiration_date",
      },
      {
        label: "Date Of Transaction",
        key: "date_of_transaction",
      }
      
     
    ],
  };
  export const signatureBenefit = [

      {
        label: "Member ID",
        key: "loyalty_id",
      },
      {
        label: "Thrive Rewards Enrollment Date",
        key: "thrive_rewards_enrollment_date",
      },
            {
        label: "Ship to ID",
        key: "customer_account_number",
      },
      {
        label: "Total Points Available",
        key: "total_points_available",
      },
      {
        label: "Dollar Value of Current Points Balance",
        key: "total_points_dollar_value",
      },
      {
        label: "Points Redeem",
        key: "points_redeem",
      },
      {
        label: "Dollar Value of Points Redeemed.",
        key: "points_redeem_dollar_value",
      },
      {
        label: "Signature Start Date",
        key: "signature_start_date",
      },
      {
        label: "Statement Generated Date",
        key: "statement_generated_date",
      },
      {
        label: "Henry Schein Product Dollar",
        key: "henry_schein_product_dollar",
      },
      {
        label: "Henry Schein Product Points",
        key: "henry_schein_product_points",
      },
      {
        label: "Equipment Dollar",
        key: "equipments_dollar",
      },
      {
        label: "Equipment Points",
        key: "equipments_points",
      },
      {
        label: "Supplier Bonus Dollar",
        key: "supplier_bonus_dollar",
      },
      {
        label: "Supplier Bonus Points",
        key: "supplier_bonus_points",
      },
      {
        label: "Thrive Signature Base Dollar",
        key: "thrive_signature_base_dollar",
      },
      {
        label: "Thrive Signature Base Points",
        key: "thrive_signature_base_points",
      }    
    ]

    export const WeeklyConsent = {
      filter: [
        {
          label: "Loyalty ID",
          key: "loyalty_id",
        },
       
        {
          label: "Billto ID",
          key: "customer_billto_account_number",
        },
        {
          label: "Consent Status",
          key: "consent_flag",
        },
        {
          label: "Consent Date",
          key: "consent_date",
        },
        {
          label: "Consent By",
          key: "consent_by",
        },
         {
          label: "Enrollment Date",
          key: "enrollment_date",
        },
        {
          label: "Request By",
          key: "request_by",
        },
        {
          label: "Role Name",
          key: "role_name",
        },
      ],
    
      columns: [
        {
          label: "Loyalty ID",
          key: "loyalty_id",
        },
       
        {
          label: "Billto ID",
          key: "customer_billto_account_number",
        },
        {
          label: "Consent Status",
          key: "consent_flag",
        },
        {
          label: "Consent Date",
          key: "consent_date",
        },
        {
          label: "Consent By",
          key: "consent_by",
        },
         {
          label: "Enrollment Date",
          key: "enrollment_date",
        },
        {
          label: "Request By",
          key: "request_by",
        },
        {
          label: "Role Name",
          key: "role_name",
        },
      ],
    
      
    };

    export const DormantRemainderTracker = {
      filter: [

        {
          label: "Loyalty ID",
          key: "loyalty_id",
        },
        {
          label: "Billto ID",
          key: "billto",
        },

        {
          label: "First Name",
          key: "first_name",
        },

        {
          label: "Last Name",
          key: "last_name",
        },

        {
          label: "Customer Role",
          key: "customer_role",
        },
       
        {
          label: "Quarter Type",
          key: "quarter_type",
        },
        {
          label: "Email Type",
          key: "email_type",
        },
        {
          label: "Email",
          key: "email",
        },
        {
          label: "Email Date Send",
          key: "email_date_send",
        },
         {
          label: "Email Open Date",
          key: "email_open_date",
        },

        {
          label: "Points Balance",
          key: "Points_Balance",
        },

        {
          label: "Points Redeemed",
          key: "points_redeemed",
        },

        {
          label: "Redemption Date",
          key: "redeemed_date",
        },
        {
          label: "Org ID",
          key: "loyalty_organization_name",
        },
        {
          label: "Site ID",
          key: "loyalty_site_id",
        },
      ],
    
      columns: [
        {
          label: "Loyalty ID",
          key: "loyalty_id",
        },
        {
          label: "Billto ID",
          key: "billto",
        },

        {
          label: "First Name",
          key: "first_name",
        },

        {
          label: "Last Name",
          key: "last_name",
        },

        {
          label: "Customer Role",
          key: "customer_role",
        },
       
        {
          label: "Quarter Type",
          key: "quarter_type",
        },
        {
          label: "Email Type",
          key: "email_type",
        },
        {
          label: "Email",
          key: "email",
        },
        {
          label: "Email Date Send",
          key: "email_date_send",
        },
         {
          label: "Email Open Date",
          key: "email_open_date",
        },

        {
          label: "Points Balance",
          key: "Points_Balance",
        },

        {
          label: "Points Redeemed",
          key: "points_redeemed",
        },

        {
          label: "Redemption Date",
          key: "redeemed_date",
        },
        {
          label: "Org ID",
          key: "loyalty_organization_name",
        },
        {
          label: "Site ID",
          key: "loyalty_site_id",
        },


      ],
    
      
    };


    export const thriveReport = {
      filter: [

        {
          label: "Thrive Loyalty Status (0,1,2)",
          key: "Thrive Loyalty Status (0,1,2)",
        },
        {
          label: "Thrive Loyalty Code",
          key: "Thrive Loyalty Code",
        },

        {
          label: "Thrive Loyalty Desc (Thrive Rewards Silver)",
          key: "Thrive Loyalty Desc (Thrive Rewards Silver)",
        },

        {
          label: "Current Thrive Loyalty Points",
          key: "Current Thrive Loyalty Points",
        },

        {
          label: "Current Thrive Loyalty Points Dollar Value",
          key: "Current Thrive Loyalty Points Dollar Value",
        },
       
        {
          label: "Thrive Loyalty Enrollment Date",
          key: "Thrive Loyalty Enrollment Date",
        },
        {
          label: "Thrive Loyalty Account Deactivation Date",
          key: "Thrive Loyalty Account Deactivation Date",
        },
        {
          label: "Thrive Loyalty Number",
          key: "Thrive Loyalty Number",
        },
        {
          label: "Thrive Loyalty Shipto ID",
          key: "Thrive Loyalty Shipto ID",
        },
         {
          label: "Thrive Loyalty Tier",
          key: "Thrive Loyalty Tier",
        },
        {
          label: "Thrive Loyalty Membership Status",
          key: "Thrive Loyalty Membership Status",
        },
        {
          label: "Thrive Loyalty Shipto Status",
          key: "Thrive Loyalty Shipto Status",
        },
        {
          label: "Thrive/Midmarket Account",
          key: "Thrive/Midmarket Account",
        },
        {
          label: "Thrive Loyalty Earning Status",
          key: "Thrive Loyalty Earning Status",
        },
        {
          label: "Thrive Loyalty Dormant Status",
          key: "Thrive Loyalty Dormant Status",
        },
        {
          label: "Thrive Loyalty Signature Status",
          key: "Thrive Loyalty Signature Status",
        },
        {
          label: "Thrive Loyalty Signature Start Date",
          key: "Thrive Loyalty Signature Start Date",
        },
        {
          label: "Thrive Loyalty Signature End Date",
          key: "Thrive Loyalty Signature End Date",
        },
        {
          label: "Thrive Loyalty Service Plus Status",
          key: "Thrive Loyalty Service Plus Status",
        },
        {
          label: "Thrive Loyalty Service Plus Start Date",
          key: "Thrive Loyalty Service Plus Start Date",
        },
        {
          label: "Thrive Loyalty Service Plus End Date",
          key: "Thrive Loyalty Service Plus End Date",
        },
        {
          label: "Thrive Loyalty Consent Status (Y/N)",
          key: "Thrive Loyalty Consent Status (Y/N)",
        },
        {
          label: "Thrive Loyalty Consent Date",
          key: "Thrive Loyalty Consent Date",
        },
        {
          label: "Current Thrive Loyalty Points Expiring Current Calendar Month",
          key: "Current Thrive Loyalty Points Expiring Current Calendar Month",
        },
        {
          label: "Current Thrive Loyalty Points Expiring Current Calendar Month Dollar Value",
          key: "Current Thrive Loyalty Points Expiring Current Calendar Month Dollar Value",
        },
        {
          label: "Current Thrive Loyalty Points Expiring Next Calendar Month",
          key: "Current Thrive Loyalty Points Expiring Next Calendar Month",
        },
        {
          label: "Current Thrive Loyalty Points Expiring Next Calendar Month Dollar Value",
          key: "Current Thrive Loyalty Points Expiring Next Calendar Month Dollar Value",
        },
        
       
      ],
    
      columns: [
        {
          label: "Thrive Loyalty Status",
          key: "Thrive Loyalty Status (0,1,2)",
        },
        {
          label: "Thrive Loyalty Code",
          key: "Thrive Loyalty Code",
        },

        {
          label: "Thrive Loyalty Desc (Thrive Rewards Silver)",
          key: "Thrive Loyalty Desc (Thrive Rewards Silver)",
        },

        {
          label: "Current Thrive Loyalty Points",
          key: "Current Thrive Loyalty Points",
        },

        {
          label: "Current Thrive Loyalty Points Dollar Value",
          key: "Current Thrive Loyalty Points Dollar Value",
        },
       
        {
          label: "Thrive Loyalty Enrollment Date",
          key: "Thrive Loyalty Enrollment Date",
        },
        {
          label: "Thrive Loyalty Account Deactivation Date",
          key: "Thrive Loyalty Account Deactivation Date",
        },
        {
          label: "Thrive Loyalty Number",
          key: "Thrive Loyalty Number",
        },
        {
          label: "Thrive Loyalty Shipto ID",
          key: "Thrive Loyalty Shipto ID",
        },
         {
          label: "Thrive Loyalty Tier",
          key: "Thrive Loyalty Tier",
        },
        {
          label: "Thrive Loyalty Membership Status",
          key: "Thrive Loyalty Membership Status",
        },
        {
          label: "Thrive Loyalty Shipto Status",
          key: "Thrive Loyalty Shipto Status",
        },
        {
          label: "Thrive/Midmarket Account",
          key: "Thrive/Midmarket Account",
        },
        {
          label: "Thrive Loyalty Earning Status",
          key: "Thrive Loyalty Earning Status",
        },
        {
          label: "Thrive Loyalty Dormant Status",
          key: "Thrive Loyalty Dormant Status",
        },
        {
          label: "Thrive Loyalty Signature Status",
          key: "Thrive Loyalty Signature Status",
        },
        {
          label: "Thrive Loyalty Signature Start Date",
          key: "Thrive Loyalty Signature Start Date",
        },
        {
          label: "Thrive Loyalty Signature End Date",
          key: "Thrive Loyalty Signature End Date",
        },
        {
          label: "Thrive Loyalty Service Plus Status",
          key: "Thrive Loyalty Service Plus Status",
        },
        {
          label: "Thrive Loyalty Service Plus Start Date",
          key: "Thrive Loyalty Service Plus Start Date",
        },
        {
          label: "Thrive Loyalty Service Plus End Date",
          key: "Thrive Loyalty Service Plus End Date",
        },
        {
          label: "Thrive Loyalty Consent Status (Y/N)",
          key: "Thrive Loyalty Consent Status (Y/N)",
        },
        {
          label: "Thrive Loyalty Consent Date",
          key: "Thrive Loyalty Consent Date",
        },
        {
          label: "Current Thrive Loyalty Points Expiring Current Calendar Month",
          key: "Current Thrive Loyalty Points Expiring Current Calendar Month",
        },
        {
          label: "Current Thrive Loyalty Points Expiring Current Calendar Month Dollar Value",
          key: "Current Thrive Loyalty Points Expiring Current Calendar Month Dollar Value",
        },
        {
          label: "Current Thrive Loyalty Points Expiring Next Calendar Month",
          key: "Current Thrive Loyalty Points Expiring Next Calendar Month",
        },
        {
          label: "Current Thrive Loyalty Points Expiring Next Calendar Month Dollar Value",
          key: "Current Thrive Loyalty Points Expiring Next Calendar Month Dollar Value",
        },
      ],


    
      
    };

    export const startupBenefit = [

      {
        label: "Member ID",
        key: "loyalty_id",
      },
      {
        label: "Thrive Rewards Enrollment Date",
        key: "thrive_rewards_enrollment_date",
      },
            {
        label: "Ship to ID",
        key: "customer_account_number",
      },
      {
        label: "Total Points Available",
        key: "total_points_available",
      },
      {
        label: "Dollar Value of Current Points Balance",
        key: "total_points_dollar_value",
      },
      {
        label: "Points Redeem",
        key: "points_redeem",
      },
      {
        label: "Dollar Value of Points Redeemed.",
        key: "points_redeem_dollar_value",
      },
      {
        label: "Startup Start Date",
        key: "startup_start_date",
      },
      {
        label: "Statement Generated Date",
        key: "statement_generated_date",
      },
      {
        label: "Henry Schein Product Dollar",
        key: "henry_schein_product_dollar",
      },
      {
        label: "Henry Schein Product Points",
        key: "henry_schein_product_points",
      },
      {
        label: "Equipment Dollar",
        key: "equipments_dollar",
      },
      {
        label: "Equipment Points",
        key: "equipments_points",
      },
      {
        label: "Supplier Bonus Dollar",
        key: "supplier_bonus_dollar",
      },
      {
        label: "Supplier Bonus Points",
        key: "supplier_bonus_points",
      },
      {
        label: "Thrive Startup Base Dollar",
        key: "thrive_startup_base_dollar",
      },
      {
        label: "Thrive Startup Base Points",
        key: "thrive_startup_base_points",
      }    
    ]

    export const UnlcokEarnReport = {
  filter: [

    {
      label: "Billto",
      key: "customer_billto_account_number",
    },
    {
      label: "Customer Number",
      key: "customer_account_number",
    },
   
    {
      label: "Practice Name",
      key: "practice_name",
    },
    {
      label: "Customer Email",
      key: "customer_email",
    },
    {
      label: "Program Type",
      key: "program_type",
    },

    {
      label: "Program Enrollment",
      key: "program_enrollment",
    },

    {
      label: "Review Status",
      key: "review_status",
    },
     {
      label: "Enrollment Date",
      key: "enrollment_date",
    },
    {
      label: "Program End Date",
      key: "program_end_date",
    },
    {
      label: "Eligibility Source",
      key: "eligibility_source",
    },
    {
      label: "Unlocked Exception",
      key: "unlocked_exception",
    },
    {
      label: "Inactive/JDE",
      key: "inactive_jde",
    },

    {
      label: "Account Sales Status",
      key: "account_sales_status",
    },

    {
      label: "Qualifying Growth Bonus Spend",
      key: "qualifying_growth_bonus_spend",
    },
    {
      label: "Current Milestone Reached",
      key: "current_milestone_reached",
    },
    {
      label: "Next Milestone",
      key: "next_milestone",
    },

    {
      label: "Dollars Remaining to Next Milestone",
      key: "dollars_remaining_to_next_milestone",
    },

    {
      label: "Total Growth Bonus Value Earned",
      key: "total_growth_bonus_value_earned",
    },

    {
      label: "Latest Points Added Date",
      key: "latest_points_added_date",
    },

    {
      label: "Eligibility Last Evaluated Date",
      key: "eligibility_last_evaluated_date",
    },

    {
      label: "Prior 365 Day Eligible Sales",
      key: "prior_365_day_eligible_sales",
    },


    {
      label: "First updated By",
      key: "first_updated_by",
    },

    {
      label: "First updated Date",
      key: "first_updated_date",
    },


    {
      label: "Last updated Date",
      key: "updated_at",
    },

    {
      label: "Last updated By",
      key: "last_updated_by",
    },
  ],

  columns: [
       {
      label: "Billto",
      key: "customer_billto_account_number",
    },
    {
      label: "Customer Number",
      key: "customer_account_number",
    },
   
    {
      label: "Practice Name",
      key: "practice_name",
    },
    {
      label: "Customer Email",
      key: "customer_email",
    },
    {
      label: "Program Type",
      key: "program_type",
    },

    {
      label: "Program Enrollment",
      key: "program_enrollment",
    },

    {
      label: "Review Status",
      key: "review_status",
    },
     {
      label: "Enrollment Date",
      key: "enrollment_date",
    },
    {
      label: "Program End Date",
      key: "program_end_date",
    },
    {
      label: "Eligibility Source",
      key: "eligibility_source",
    },
    {
      label: "Unlocked Exception",
      key: "unlocked_exception",
    },
    {
      label: "Inactive/JDE",
      key: "inactive_jde",
    },

    {
      label: "Account Sales Status",
      key: "account_sales_status",
    },

    {
      label: "Qualifying Growth Bonus Spend",
      key: "qualifying_growth_bonus_spend",
    },
    {
      label: "Current Milestone Reached",
      key: "current_milestone_reached",
    },
    {
      label: "Next Milestone",
      key: "next_milestone",
    },

    {
      label: "Dollars Remaining to Next Milestone",
      key: "dollars_remaining_to_next_milestone",
    },

    {
      label: "Total Growth Bonus Value Earned",
      key: "total_growth_bonus_value_earned",
    },

    {
      label: "Latest Points Added Date",
      key: "latest_points_added_date",
    },

    {
      label: "Eligibility Last Evaluated Date",
      key: "eligibility_last_evaluated_date",
    },

    {
      label: "Prior 365 Day Eligible Sales",
      key: "prior_365_day_eligible_sales",
    },

     {
      label: "First updated By",
      key: "first_updated_by",
    },

    {
      label: "First updated Date",
      key: "first_updated_date",
    },

    {
      label: "Last updated Date",
      key: "updated_at",
    },

    {
      label: "Last updated By",
      key: "last_updated_by",
    },
  ],

  
};


export const UnlockOriginReport = {
  filter: [

    {
      label: "Member ID",
      key: "loyalty_id",
    },
    {
      label: "Billto ID",
      key: "customer_billto_account_number",
    },
   
    {
      label: "Shipto",
      key: "customer_account_number",
    },
    {
      label: "Practice Name",
      key: "customer_name",
    },
    {
      label: "Prior Program",
      key: "prior_program",
    },

    {
      label: "Current Enrollment",
      key: "plan",
    },

    {
      label: "Unlocked Start Date",
      key: "start_date",
    },
     {
      label: "Unlocked End Date",
      key: "end_date",
    },
    {
      label: "Unlocked Qualified Spend",
      key: "total_sales",
    },
    {
      label: "Status",
      key: "status",
    },
    {
      label: "Program Progression",
      key: "program_progression",
    },
      ],


  columns :[

    {
      label: "Member ID",
      key: "loyalty_id",
    },
    {
      label: "Billto ID",
      key: "customer_billto_account_number",
    },
   
    {
      label: "Shipto",
      key: "customer_account_number",
    },
    {
      label: "Practice Name",
      key: "customer_name",
    },
    {
      label: "Unlocked Start Date",
      key: "start_date",
    },
     {
      label: "Unlocked End Date",
      key: "end_date",
    },
    {
      label: "Unlocked Qualified Spend",
      key: "total_sales",
    },
    {
      label: "Status",
      key: "status",
    },
    {
      label: "Prior Subscription",
      key: "prior_program",
    },

    {
      label: "Current Subscription",
      key: "plan",
    },
  ],

  
};

export const UnlockShiptoEarnReport = {
  filter: [
    {
      label: "Loyalty Account Id",
      key: "loyalty_id",
    },
    {
      label: "Bill To",
      key: "customer_billto_account_number",
    },
    {
      label: "Ship to ID",
      key: "customer_account_number",
    },
    // {
    //   label: "Brand Name Code",
    //   key: "product_brand_name_code",
    // },
    // {
    //   label: "Cost Center",
    //   key: "gl_cost_center_code",
    // },
    // {
    //   label: "Primary Class ID",
    //   key: "product_primary_class_id",
    // },
    // {
    //   label: "Rule ID",
    //   key: "rule_id",
    // },
    // {
    //   label: "Promotional",
    //   key: "is_promotional",
    //   type: "Boolean",
    // },
    // {
    //   label: "Order ID",
    //   key: "order_id",
    // },
    // {
    //   label: "Transaction Type",
    //   key: "transaction_type",
    // },
  ],
  filterDataType: {
    is_promotional: "Boolean",
  },
  group: [
    {
      label: "Bill To",
      key: "customer_billto_account_number",
    },
    {
      label: "Loyalty Account ID",
      key: "loyalty_id",
    },
    // {
    //   label: "Brand Name Code",
    //   key: "product_brand_name_code",
    // },
    // {
    //   label: "Cost Center",
    //   key: "gl_cost_center_code",
    // },
    // {
    //   label: "Primary Class ID",
    //   key: "product_primary_class_id",
    // },
    // {
    //   label: "Transaction Type",
    //   key: "transaction_type",
    // },
    // {
    //   label: "Label Class Code",
    //   key: "label_class_code",
    // },
    // {
    //   label: "Order ID",
    //   key: "order_id",
    // },
    // {
    //   label: "Rule ID",
    //   key: "rule_id",
    // },
  ],
  columns: [
    {
      label: "Loyalty ID",
      key: "loyalty_id",
    },
    {
      label: "Bill to Account ID",
      key: "customer_billto_account_number",
    },
    {
      label: "Ship to ID",
      key: "customer_account_number",
    },
    {
      label: "Purchase Amount",
      key: "extended_sales_amount",
    },
    {
      label: "Points Allocated",
      key: "points",
    },
    {
      label: "Expiration Date",
      key: "points_expiration_date",
    },
    {
      label: "Order Date",
      key: "order_date",
    },
    {
      label: "Rule Description",
      key: "rule_description",
    },
    {
      label: "Cost Center",
      key: "gl_cost_center_code",
    },
    {
      label: "Promotional",
      key: "is_promotional",
    },
    {
      label: "Transaction Type",
      key: "transaction_type",
    },
    {
      label: "Type",
      key: "type",
    },
    {
      label: "Label Class Code",
      key: "label_class_code",
    },
    {
      label: "Product Code",
      key: "product_code",
    },
    {
      label: "Brand Name Code",
      key: "product_brand_name_code",
    },
    {
      label: "Loyalty Category Code",
      key: "loyalty_category_code"
    },
    {
      label: "Order ID",
      key: "order_id",
    },
    {
      label: "Rule ID",
      key: "rule_id",
    },
    {
      label: "Primary Class ID",
      key: "product_primary_class_id",
    },
    {
      label: "Primary Class Description",
      key: "product_primary_class_description",
    },
    {
      label: "Post Date",
      key: "post_date",
    },
    {
      label: "Transaction Status",
      key: "transaction_status",
    },
    {
      label: "Sales Division Code",
      key: "customer_sales_division_code",
    },
    {
      label: "Market Class",
      key: "market_class_code",
    },
    {
      label: "Segment Code",
      key: "segment_code",
    },
    {
      label: "Tier",
      key: "tier",
    },
    {
      label: "Consent Status",
      key: "consent_flag",
    },
    // {
    //   label: "Is Bronze",
    //   key: "IsBronze",
    // },
    {
      label: "Primary Major Class Code",
      key: "primary_major_class_code",
    },

    {
      label: "Primary Submajor Class Code",
      key: "primary_submajor_class_code",
    },

    {
      label: "Primary Minor Class Code",
      key: "primary_minor_class_code",
    },

    {
      label: "Tier Ratio",
      key: "tier_ratio",
    },
    {
      label:"Billto Province Code",
      key:"billto_province_code"
    },
    {
      label:"Shipto Province Code",
      key:"shipto_province_code"
    },
  ],
};
export const GrowthBonusMailTracker = {
  filter: [

    // {
    //   label: "Loyalty ID",
    //   key: "loyalty_id",
    // },
    // {
    //   label: "Billto ID",
    //   key: "customer_billto_account_number",
    // },
    // {
    //   label: "Customer Role",
    //   key: "customer_role",
    // },
    //  {
    //   label: "Email Type",
    //   key: "email_type",
    // },
    {
      label: "Email",
      key: "email",
    },
    {
      label: "Email Sent Date",
      key: "email_sent_at",
    },
     {
      label: "Email Opened Date",
      key: "email_opened_at",
    },
  ],

  columns: [
    // {
    //   label: "Loyalty ID",
    //   key: "loyalty_id",
    // },
    // {
    //   label: "Billto ID",
    //   key: "customer_billto_account_number",
    // },
    // {
    //   label: "Customer Role",
    //   key: "customer_role",
    // },
    // {
    //   label: "Email Type",
    //   key: "email_type",
    // },
    {
      label: "Email",
      key: "email",
    },
    {
      label: "Email Sent Date",
      key: "email_sent_at",
    },
     {
      label: "Email Opened Date",
      key: "email_opened_at",
    },
 
  ],

  
};

export const UnlockMilestoneTrackerapi = {
  filter: [

    {
      label: "Loyalty ID",
      key: "loyalty_id",
    },
    {
      label: "Billto ID",
      key: "customer_billto_account_number",
    },
   
     {
      label: "Email Type",
      key: "email_type",
    },
    {
      label: "Email",
      key: "email",
    },
    {
      label: "Email Sent Date",
      key: "email_sent_at",
    },
     {
      label: "Email Opened Date",
      key: "email_opened_at",
    },
  ],

  columns: [
    {
      label: "Loyalty ID",
      key: "loyalty_id",
    },
    {
      label: "Billto ID",
      key: "customer_billto_account_number",
    },
    
    {
      label: "Email Type",
      key: "email_type",
    },
    {
      label: "Email",
      key: "email",
    },
    {
      label: "Email Sent Date",
      key: "email_sent_at",
    },
     {
      label: "Email Opened Date",
      key: "email_opened_at",
    },
 
  ],

  
};


export const SigatureMilestoneTrackerapi = {
  filter: [

    {
      label: "Loyalty ID",
      key: "loyalty_id",
    },
    {
      label: "Billto ID",
      key: "customer_billto_account_number",
    },
   
     {
      label: "Email Type",
      key: "email_type",
    },
    {
      label: "Email",
      key: "email",
    },
    {
      label: "Email Sent Date",
      key: "email_sent_at",
    },
     {
      label: "Email Opened Date",
      key: "email_opened_at",
    },
  ],

  columns: [
    {
      label: "Loyalty ID",
      key: "loyalty_id",
    },
    {
      label: "Billto ID",
      key: "customer_billto_account_number",
    },
    
    {
      label: "Email Type",
      key: "email_type",
    },
    {
      label: "Email",
      key: "email",
    },
    {
      label: "Email Sent Date",
      key: "email_sent_at",
    },
     {
      label: "Email Opened Date",
      key: "email_opened_at",
    },
 
  ],

  
};